import { render } from "./notify_product.vue?vue&type=template&id=91b02be4"
import script from "./notify_product.vue?vue&type=script&lang=js"
export * from "./notify_product.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__